<template>
    <div class="sign">

        <div class="sign_right">

            <!-- 合同预览界面 -->
            <div class="puint">
                <div class="title">合同预览</div>
                <div class="desc">请选择合适的页面尺寸后，点击"生成合同"</div>
                 <div class="detal_title">
                     <label class="radioLabel">
                         <div class="circle">
                             <div class="circle-flex">
                                 <div class="circle-btn" :class="{'circle-btn-active':radioCheck==1}"></div>
                                 <div class="circle-center" :class="{'circle-center-active':radioCheck==1}"></div>
                             </div>
                         </div>
                         <input style="display: none" type="radio" name="radios" value="1" v-model="radioCheck">
                         原始尺寸: {{data.pageSize.w}}x{{data.pageSize.h}}
                     </label>
                     <label class="radioLabel">
                         <div class="circle">
                             <div class="circle-flex">
                                 <div class="circle-btn" :class="{'circle-btn-active':radioCheck==2}"></div>
                                 <div class="circle-center" :class="{'circle-center-active':radioCheck==2}"></div>
                             </div>
                         </div>
                         <input style="display: none" type="radio" name="radios" value="2" v-model="radioCheck">
                         缩放尺寸: {{data.pw}}x{{data.ph}}
                     </label>

                    <div class="pusth">
                        <div class="save"  @click="changeToA4" >一键标准尺寸</div>
                    </div>
                    <div class="pusth">
                        <div class="save"  @click="handlCheckSave" >生成合同</div>
                    </div>
                </div>

            </div>

            <div class="preview">
                <my-preview :src="pdfPath" :can-rotate="false" @change="handlerChange"></my-preview>
            </div>

        </div>
    </div>
</template>

<script>
import MyPreview from '../../preview/preview'

export default {
    components: {
        MyPreview,
    },
    data() {
        return {
            pdfPath: '',
            isShu: 0,
            radioCheck: '1',
            data: {
                pw: 1,
                ph: 1,
                pageSize: {w: 1, h:1},
            },
        }
    },

    computed: {
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },

    created() {

        console.log("进入该页面传参", this.$route.params );
        if (this.$route.params.id || this.$route.params.yes) {
            this.pdfPath = this.$route.params.pdfPath
            window.addEventListener('scroll', this.handleScroll);
        } else {
            this.$router.push('contractSin');
        }

    },

    mounted() {


    },

    methods: {


        handlCheckSave() {
            let _this = this;
            
            // 封装请求参数
            let param = new FormData();
            param.append('token', _this.$global.token);
            param.append('templateId', _this.$route.params.id);
            param.append('title', _this.$route.params.title);
            if(_this.radioCheck==2){
                param.append('width', _this.data.pw);
                param.append('height', _this.data.ph);
                
            }

            // 【API】请求----根据pdf生成合同
            _this.api.createContactByPdf( param ).then(res => {

                console.log(res);
                _this.$message.success("合同生成成功");
                setTimeout(() => {
                    console.log(res);
                    _this.$router.push('contractSin');
                }, 1000);

            })

        },
        handlerChange(data){
            this.data = data
        },
        changeToA4(){
            if(this.isShu == 0){
                this.data.pw=595;
                this.data.ph=842;
                this.isShu = 1;
            }else{
                this.data.ph=595;
                this.data.pw=842;
                this.isShu = 0;
            }
           
        }
    }
}
</script>

<style scoped lang="less">
@import '../../../../static/less/xm.less';


.detal_title {
    width: @a;
    height: 40px;
    display: inline-block;
    text-align: left;
    
    margin-top: 11px;

    .radioLabel {
        -webkit-user-select: none;
        font-size: 24px;

        
    
        
    
    }
    .radioLabel + .radioLabel{
        margin-left: 20px;
    }
    .circle{
    
        display: inline-block;
    }
    .circle-flex{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circle-btn {
        width: 20px;
        height: 20px;
        border-radius: 100%;
        border: 2px solid #808080;
        transition: all 0.4s;
        -moz-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        vertical-align: middle;
    }
    .circle-btn-active {
        border-width: 2px;
        border-color: #1dace8;
    }
    .circle-center {
        width: 14px;
        height: 14px;
        margin-left: -17px;
        border-radius: 100%;
        transition: all 0.4s;
        -moz-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        vertical-align: middle;
        background-color: white;
    }
    .circle-center-active {
        background-color: #1dace8;
    }

    .pusth {
        width: 150;
        height: @a;
        margin-left: 20px;
        display: inline-block;

        .title {
            width: 160px;
            height: auto;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .save:active {
            background-image: linear-gradient(270deg,
            #1e6eee 0%,
            #109ee7 50%,
            #01cee0 100%),
            linear-gradient(#000000,
            #000000);
            background-blend-mode: normal, normal;
            color: #333333;
        }

        .save {
            background-image: linear-gradient(270deg,
            #1e6eee 0%,
            #109ee7 50%,
            #01cee0 100%),
            linear-gradient(#000000,
            #000000);
            background-blend-mode: normal, normal;
            color: #ffffff;

            width: 140px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #f2f2f2;
            border: solid 1px #aaaaaa;
            letter-spacing: 1px;

            // margin-left: 22px;
            cursor: pointer;
            font-size: 20px;
        }
    }
}


.sign {
  width: @a;
  height: auto;

  .sign_right {
    width: @a;
    height: auto;
    margin-left: 4%;
    position: relative;
    overflow: hidden;

    .puint {
      width: auto;
      height: auto;

      .title {
        width: 672px;
        height: 24px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
      }
      .desc{
          margin-top: 20px;
          font-family: MicrosoftYaHei-Bold;
          font-size: 18px;
          color: red;
      }
    }

    .preview{
        width: 96%;
        padding-left: 10px;
        padding-right: 10px;
        background-color: #f5f5f5;
        margin-top: 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/page/contract/templateDetailPdf.vue